function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "22",
  viewBox: "0 0 24 22"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.481 0c2.067 0 3.728 1.73 3.728 3.844v1.589c0 .52-.758.941-1.278.941A.933.933 0 0115 5.433v-1.59C15 2.754 14.492 2 13.481 2H3c-.919 0-.993.751-1 1.707v13.558C2.004 18.374 2.067 20 3 20h10c1.01 0 2-1.279 2-2.37v-1.794c0-.52.412-.942.931-.942.52 0 1.278.422 1.278.942v1.794c0 2.114-2.142 4.37-4.209 4.37H3c-2.067 0-3-2.256-3-4.37V3.844C0 1.729 1.66 0 3.728 0zm7.443 7.516l2.764 2.764a1.067 1.067 0 010 1.509l-2.764 2.764a.94.94 0 11-1.33-1.331l1.541-1.544H12c-.483 0-.504-.363-.505-.831v-.11c0-.52.421-.942.941-.942h8.105l-.948-.948a.942.942 0 011.331-1.331z"
}));